var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"linkNoLimit"},[_c('img',{staticClass:"linkImg",attrs:{"src":require("../../assets/images/linkEmpty.png"),"alt":""}}),_c('span',[_vm._v("链接已失效")])])
}]

export { render, staticRenderFns }